import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"


const PROPERTY = "reference"

export const schema = Validation.string("This is required")


const Reference = ({survey, onChange, required, label, ...props}) => {
  return (
    <Input
      name={PROPERTY}
      type="text"
      value={get(survey, PROPERTY)}
      onChange={(value) => onChange(survey, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

Reference.propTypes = {
  survey: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.object
}

Reference.defaultProps = {
  required: true,
  placeholder: "Reference",
  label: "Reference",
  hint: "This is purely for you to remember who the survey is for",
  validation: schema,
  id: PROPERTY
}

export default Reference
